module.exports = __webpack_public_path__ + "img/live-off.3253b024.png";